import { useEffect } from 'react';

import { useUserMatchScoresState, useUserMatchScoresActions } from './UserMatchScoresContext';
import { getUserMatchScores } from './restApi';

const UserMatchScoresLoader = () => {
  const state = useUserMatchScoresState();
  const { onResponse, onError } = useUserMatchScoresActions();

  useEffect(() => {
    if (state?.userId && state?.loading) {
      getUserMatchScores({
        userId: state.userId,
        pageNumber: 1,
        sortBy: state.sortBy,
        sortDirection: state.sortDirection,
        gapFilter: state.gapFilter,
        onResponse,
        onError,
      });
    }
  }, [state?.userId, state?.loading]);

  return null;
};

export default UserMatchScoresLoader;
